import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/app/shell/Sidebar';
import { Header } from '@/app/shell/Header';
import { ThemeSwitcherPanel } from '@/app/shell/ThemeSwitcherPanel';
import { ToastViewport } from '@/components/ui/Toast';

/** Yönetim arayüzünün ana kabuğu: sol menü + üst bar + içerik. */
export function AdminLayout() {
  const [themePanelOpen, setThemePanelOpen] = useState(false);

  return (
    <div className="app-shell">
      {/* Klavye kullanıcıları menüyü her sayfada baştan geçmek zorunda kalmasın. */}
      <a className="skip-link" href="#main-content">
        İçeriğe atla
      </a>

      <Sidebar />

      <div className="app-content">
        <Header onOpenThemePanel={() => setThemePanelOpen(true)} />

        <main id="main-content">
          <Outlet />
        </main>

        <footer className="app-footer">
          <div className="d-flex flex-wrap justify-content-between gap-2">
            <span>© {new Date().getFullYear()} MallOS — Apex Technology</span>
            <span className="text-muted">v0.1.0</span>
          </div>
        </footer>
      </div>

      <ThemeSwitcherPanel show={themePanelOpen} onHide={() => setThemePanelOpen(false)} />

      {/* Bildirimler kabuk düzeyinde: her ekran ayrı viewport kurmaz. */}
      <ToastViewport />
    </div>
  );
}
